import { toStoreTask } from 'utils/to-store-task';
/**
 * The collection holds api-shaped `Task` (nested `project`, `fields[]` array).
 * AgGrid rows and many legacy components consume the store-shaped `Task`
 * (flattened custom fields, `project` as a number, `assignee` as
 * `AssigneeValue[]`). This module bridges api → store at the read boundary so
 * the collection can stay the single source of truth without changing what
 * those consumers receive.
 */ /** api Task → the normalized shape `toStoreTask` consumes (project flattened). */ export const apiToNormalized = (task)=>{
    var _ref;
    const { subTasks, dependentTasks, project, parentTaskId, ...rest } = task;
    return {
        ...rest,
        project: (_ref = project === null || project === void 0 ? void 0 : project.projectId) !== null && _ref !== void 0 ? _ref : 0,
        parentTask: parentTaskId !== null && parentTaskId !== void 0 ? parentTaskId : task.parentTask,
        subTasks: (subTasks !== null && subTasks !== void 0 ? subTasks : []).map((sub)=>sub.taskId),
        dependentTasks: (dependentTasks !== null && dependentTasks !== void 0 ? dependentTasks : []).map(apiToNormalized)
    };
};
/**
 * Convert an api-shaped Task (as stored in `taskCollection`) into the
 * store-shaped Task that AgGrid / legacy components expect.
 *
 * `fieldLookup` (fieldId → TaskField) is required to flatten custom fields —
 * the read site already has it (datasources/components pass `taskFields`).
 * `tasksLookup` is only needed to build the `taskTree`; defaults to empty.
 */ export const apiTaskToStoreTask = (task, fieldLookup, tasksLookup = {})=>toStoreTask(fieldLookup, tasksLookup)(apiToNormalized(task));
